<script lang="ts">
  import {onMount} from 'svelte';
  import InlineSVG from 'svelte-inline-svg';

  import {auth, user, tokenClient} from '../../stores/user';

  import googleLogo from '../../assets/icons/google-logo.svg';
  import logoutIcon from '../../assets/icons/logout.svg';

  const loadGoogleIdentityService = () => {
    const scriptTag = document.createElement('script');
    scriptTag.setAttribute('type', 'text/javascript');
    scriptTag.setAttribute('async', 'async');
    scriptTag.setAttribute('defer', 'defer');
    scriptTag.setAttribute('src', 'https://accounts.google.com/gsi/client');
    scriptTag.onload = auth.initialize;

    document.getElementsByTagName('head')[0].appendChild(scriptTag);
  };

  onMount(loadGoogleIdentityService);
</script>

<style lang="postcss">
  .account {
    grid-column: 5;
    display: flex;
    gap: 0.5rem;
    color: var(--ubilabs-gray-dark-2);
  }

  .account > span {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 40px;
    margin: 0;
  }

  @media (max-width: 999px) {
    .account > span {
      display: none;
    }
  }

  /**
  * Sign in button styles according to the Google Branding Guidelines
  * https://developers.google.com/identity/branding-guidelines
  */
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap');

  .googleSignInButton,
  .signOutButton {
    grid-column: 5;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    height: 40px;
    padding: 8px;
    border-radius: 0.125rem;
    background-color: #fff;
    color: rgba(0, 0, 0, 0.54);
    text-decoration: none;
    letter-spacing: initial;
    transition: all 0.2s;
  }

  .googleSignInButton:hover,
  .googleSignInButton:focus,
  .signOutButton:hover,
  .signOutButton:focus {
    background-color: #eee;
    text-decoration: none;
  }

  .googleSignInButton .text,
  .signOutButton .text {
    margin-inline-end: 0.75rem;
  }

  .googleSignInButton .icon {
    display: flex;
    font-size: 24px;
  }

  .googleSignInButton .text {
    margin-left: 1rem;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 500;
  }

  @media (max-width: 767px) {
    .googleSignInButton .text,
    .signOutButton .text {
      display: none;
    }
  }

  @media (min-width: 768px) and (max-width: 999px) {
    .googleSignInButton .text > span {
      display: none;
    }
  }
</style>

{#if $user}
  <div class="account">
    <button
      class="signOutButton"
      on:click={auth.logout}
      aria-labelledby="sign-out-label">
      <span id="sign-out-label" class="text"
        >{#if $user.displayName}
          <span class="userName">{$user.displayName}</span>{/if}</span>
      <InlineSVG src={logoutIcon} />
    </button>
  </div>
{:else}
  <button
    class="googleSignInButton"
    on:click={auth.login}
    disabled={!$tokenClient}
    aria-labelledby="google-sign-in-label">
    <span class="icon"><InlineSVG src={googleLogo} /></span>
    <span id="google-sign-in-label" class="text"
      >Sign in <span>with Google</span>
    </span>
  </button>
{/if}
